// Models
import Model from './Model'

class ForexCurrencyLimits extends Model {
  get schema () {
    return [
      'paymentsEnabled',
      'usPaymentsEnabled',
      'currency',
      'dayOperationLimit',
      'dayPeriodLimit',
      'dayBalanceLimit',
      'nightOperationLimit',
      'nightPeriodLimit',
      'nightBalanceLimit',
      'weekendOperationLimit',
      'weekendPeriodLimit',
      'weekendBalanceLimit'
    ]
  }
}

export default ForexCurrencyLimits
